// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"453":"gift","594":"about","661":"gift-detail","699":"art-trade","720":"heritage","996":"cultural-mall"}[chunkId] || chunkId) + "." + {"453":"62ef674a","457":"922c4e4d","594":"82ea4a66","661":"0d6bc3e7","699":"52871eff","720":"41d13931","778":"1a0e49a3","996":"6f771779"}[chunkId] + ".js";
};